import * as Yup from "yup";

export default () =>
  Yup.object().shape({
    email: Yup.string().email().required(),
    first_name: Yup.string().required().min(3),
    last_name: Yup.string().required().min(3),
  });
